module.exports = __webpack_public_path__ + "media/images/logos/computing_quality_framework_logo-7519d92a5d0192ae0760483ca91748d3.png";